import axios from 'axios'
import { EventEmitter } from 'events'

import { eventEmitter } from '../'
import { getToken } from '../services/storage.service'

export const getApiHost = () => {
  let apiHost

  const hostname = window && window.location && window.location.hostname
  const completeUrl = window && window.location.toString()
  console.log('apiClient.ts - completeUrl: ' + completeUrl)

  if (completeUrl.indexOf('calculator/vehicles') !== -1) {
    console.log('apiClient.ts - We are on calculator/vehicles')
  }

  if (completeUrl.indexOf('clo-secure') !== -1) {
    console.log('apiClient.ts - We are on secure')
  }

  if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_LOCAL) {
    apiHost = process.env.REACT_APP_API_BASE_URL_LOCAL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_DEVL) {
    apiHost = process.env.REACT_APP_API_BASE_URL_DEVL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_INTG) {
    apiHost = process.env.REACT_APP_API_BASE_URL_INTG
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_PROD) {
    apiHost = process.env.REACT_APP_API_BASE_URL_PROD
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_DEVL) {
    apiHost = process.env.REACT_APP_API_BASE_URL_SECURE_DEVL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_INTG) {
    apiHost = process.env.REACT_APP_API_BASE_URL_SECURE_INTG
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_PROD) {
    apiHost = process.env.REACT_APP_API_BASE_URL_SECURE_PROD
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_DEVL) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_DEVL
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_INTG) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_INTG
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_PROD) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_PROD
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_DEVL
  ) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_SECURE_DEVL
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_INTG
  ) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_SECURE_INTG
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_PROD
  ) {
    apiHost = process.env.REACT_APP_API_NOWAF_URL_SECURE_PROD
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_DEVL) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_DEVL
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_INTG) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_INTG
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_PROD) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_PROD
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_DEVL
  ) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_SECURE_DEVL
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_INTG
  ) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_SECURE_INTG
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_PROD
  ) {
    apiHost = process.env.REACT_LEGACY_APP_API_NOWAF_URL_SECURE_PROD
  } else {
    apiHost = ''
  }

  return apiHost
}

const events = new EventEmitter()
const SERVER_ERROR = Symbol('server_error')
const instance = axios.create({
  baseURL: getApiHost(),
  withCredentials: false,
})

interceptAndEmitResponseErrors()

function interceptAndEmitResponseErrors() {
  instance.interceptors.response.use(
    response => response,
    error => {
      const statusError = JSON.parse(error.request.response)

      if (!error.status && statusError.status) {
        switch (statusError.status) {
          case 401:
            eventEmitter.emit(Events.ERROR_401, error)
            break
          default:
            throw error
        }
      } else if (error.response) {
        switch (error.response.status) {
          case 403:
            eventEmitter.emit(Events.ERROR_403, error)
            break
          case 404:
            eventEmitter.emit(Events.ERROR_404, error)
            break
          default:
            throw error
        }
      }
    },
  )
}

function setDefaultHeader(name: string, value: string) {
  instance.defaults.headers.common[name] = value
}

function removeAuthorizationFromDefaultHeader() {
  delete instance.defaults.headers.common['Authorization']
}

function getDefaultHeaders(): void {
  const token = getToken()
  if (token) {
    setDefaultHeader('Authorization', `Bearer ${token}`)
  } else {
    removeAuthorizationFromDefaultHeader()
  }
}

export enum Events {
  ERROR_401 = 'error401',
  ERROR_403 = 'error403',
  ERROR_404 = 'error404',
}

export default {
  get: function<P>(path: string, params?: Object) {
    getDefaultHeaders()
    return instance.get<P>(path, params).then(response => response.data)
  },

  post: function<P = void>(path: string, data?: Object) {
    getDefaultHeaders()
    return instance.post<P>(path, data).then(response => response.data)
  },

  put: function<P = void>(path: string, data?: Object) {
    getDefaultHeaders()
    return instance.put<P>(path, data).then(response => response.data)
  },

  onServerError: function(callback: (error: any) => void) {
    events.addListener(SERVER_ERROR, callback)
  },
}
